// extracted by mini-css-extract-plugin
export default {"hide4printing":"Sales_hide4printing__xvx6i","margin4printing":"Sales_margin4printing__4UxZ2"};